<template>
  <div>
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="lz_abouts">
      <div class="about_title">
        简介
      </div>
      <div class="coutents">
        <p> 太仓聚一堂网络科技有限公司成立于2016年11月25日，
        法定代表人为范伟程。经营范围包括网络技术开发、
        游戏软件开发、设计及技术转让；动漫设计及技术转让；
        计算机及辅助设备的研发、设计、销售；会议及展览服务；
        广告设计、制作、代理、发布；从事经营性互联网文化活动；
        制作广播电视节目（不得制作时政新闻类广播电视节目）；
        演出组织，演出居间，演员签约，演员推广，演出代理，演出制作，
        演出营销，演出经纪，演员代理；自营和代理各类商品及技术的进出口业务
        （国家限定企业经营或禁止进出口的商品和技术除外）。</p>
          <div style="margin-top: 12px; display: flex;justify-content: flex-start;">
           地址：太仓市城厢镇南郊海运堤路86-2号</div>
           <div style="margin-top: 1px;display: flex;justify-content: flex-start;">
           电话：400 159 9907
          </div>
     </div>
    </div>
  </div>
</template>

<script>
  import Nav from "../../component/Nav.vue";
  export default {
    data() {
      return {};
    },
    components: {
      Nav,
    },
  };
</script>

<style lang='scss' scope>
  .lz_abouts {
    display: flex;
    align-items: center;

    flex-direction: column;
    background: linear-gradient(to bottom right, #f9f9f9, 50%, #f3f3f3);
    height:calc(100vh - 88px);
    .about_title {
      border-radius: 4px;
      overflow: hidden;
      max-width: 75vh;
    }
    .coutents{
      max-width:1080px;
      color: #333;
      line-height: 46px;
      letter-spacing:1px;
      p{
        text-indent: 2rem;
      }
    }
    .about_title{
      font-size: 24px;
      margin: 38px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/about.vue